import { utils } from './utils';
import { _, each } from 'lodash';
import { config } from './../config';
const nav = {
  flipTitle (config) {
    var target = document.querySelector(config.titleEl);
    target.style.opacity = 0;
    document.onreadystatechange = function (selector) {
      if (document.readyState == "interactive") {
        target.classList.add('is-flipping');
        target.style.opacity = 1;
      }
    };
  },
  logoAnim (config) {
    var target = document.querySelector(config.titleEl);
    target.style.opacity = 0;
    document.onreadystatechange = function (selector) {
      if (document.readyState == "interactive") {
        target.classList.add('logo-anim');
        target.style.opacity = 1;
      }
    };
  },
  toggle (trigger, selector) {
    var el = document.querySelector(trigger);
    var target = document.querySelector(selector);
    if (utils.isMobile()) {
      var touchEvent = el.addEventListener('touchend', function () {
        el.parentElement.classList.toggle('has-click');
        el.classList.toggle('has-click');
        target.classList.toggle('collapse');
      });
      utils.Log(['touchend', el, touchEvent]);
    } else {
      el.addEventListener('mouseover', function () {
        el.parentElement.classList.add('has-click');
        el.classList.add('has-click');
        target.classList.add('collapse');
      });
      el.addEventListener('click', function () {
        el.parentElement.classList.toggle('has-click');
        el.classList.toggle('has-click');
        target.classList.toggle('collapse');
      });
    }
  },
  toggleAll (triggers, selectors) {
    var els = document.querySelectorAll(triggers);
    var targets = document.querySelectorAll(selectors);
    // console.log('test toggleAll', triggers, selectors);
    utils.Log('test utils', utils.screenDimensions);
    if (utils.isMobile()) {
      utils.Log('is mobile');
      _.each(els, function (el, index) {
        // console.log(el, index);
        var target = targets[index];
        els[index].addEventListener('touchend', function () {
          // console.log('touchend');
          target.classList.toggle('collapse');
          el.classList.toggle('has-click');
          el.parentElement.classList.toggle('has-click');
        });
      });
    } else {
      utils.Log('is not mobile');
      const leaveTrigger = document.querySelector('.docnav');
      const leaveTrigger2 = document.querySelector('.sub-menu');
      _.each(els, function (el, index) {
        // console.log(el, index);
        var target = targets[index];
        els[index].addEventListener('click', function () {
          // console.log('click');
          target.classList.toggle('collapse');
          el.classList.toggle('has-click');
          el.parentElement.classList.toggle('has-click');
        });
        els[index].addEventListener('mouseover', function () {
          // console.log('hover');
          target.classList.add('collapse');
          el.classList.add('has-click');
          el.parentElement.classList.add('has-click');
        });
        leaveTrigger.addEventListener('mouseleave', function () {
          // console.log('hover');
          target.classList.remove('collapse');
          el.classList.remove('has-click');
          el.parentElement.classList.remove('has-click');
        });
        leaveTrigger2.addEventListener('mouseleave', function () {
          // console.log('hover');
          target.classList.remove('collapse');
          el.classList.remove('has-click');
          el.parentElement.classList.remove('has-click');
        });
      });
    }
  }
};
export {nav};
